<template>
  <div :id="`${category.name}`" class="category-wrapper">
    <!-- <div class="dropdown-wrapper">
      <Dropdown :options="actions" iconColor="black" />
    </div>-->
    <div class="cat-title">{{category.title}}</div>
    <div v-if="category.description" class="cat-description">{{category.description}}</div>
    <div
      class="no-data"
      v-if="!items"
    >There are no items in this category yet. Click below to add item</div>

    <div v-else class="cat-items">
      <template v-for="(item) in items">
        <ItemCard :key="item.id" :index="item.id" :total="items.length" :item="item" :editable="false" />
      </template>
    </div>
  </div>
</template>

<script>
import ItemCard from "./ItemCard";
export default {
  props: {
    category: Object,
    index: String,
    menuId: String,
    categories: Array,
    companyId:String
  },
  components: {
    ItemCard
  },
  methods: {
    getItems() {
      this.$store.dispatch("Category/fetchCategoryItems", {
        categoryName: this.category.name,
        items: this.category.items,
        load: true,
        companyId:this.companyId
      });
    }
  },
  computed: {
    items() {
      return this.$store.state.Category[this.category.name];
    }
  },
  mounted() {
    this.getItems();
  }
};
</script>

<style>
</style>